import { render, staticRenderFns } from "./DetailPengembalian.vue?vue&type=template&id=0f0d1148"
import script from "./DetailPengembalian.vue?vue&type=script&lang=js"
export * from "./DetailPengembalian.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports